import { render, staticRenderFns } from "./StageEmpty.vue?vue&type=template&id=3fff0607&"
import script from "./StageEmpty.vue?vue&type=script&lang=js&"
export * from "./StageEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports